// extracted by mini-css-extract-plugin
module.exports = {"chartsContainer":"DemographicsReporting_chartsContainer__Izpix","chartContainer":"DemographicsReporting_chartContainer__22vB3"};